import { apiFetch, apiFetchBlob } from './client.js';

export interface AdminStatement {
  id: string;
  accountId: string;
  periodStart: string;
  periodEnd: string;
  format: 'PDF' | 'CSV' | 'CAMT053_XML' | 'UNSPECIFIED';
  currency: string;
  generatedAt: string;
  entryCount: number;
  openingBalanceCents: string;
  closingBalanceCents: string;
}
export interface StatementPeriod {
  periodStart: string;
  periodEnd: string;
  format: 'PDF' | 'CSV';
}
const path = (customerId: string, accountId: string): string =>
  `/admin/customers/${encodeURIComponent(customerId)}/accounts/${encodeURIComponent(accountId)}/statements`;

export const statementsApi = {
  list: (customerId: string, accountId: string): Promise<AdminStatement[]> =>
    apiFetch(path(customerId, accountId)),
  generate: (customerId: string, accountId: string, input: StatementPeriod): Promise<AdminStatement> =>
    apiFetch(path(customerId, accountId), { method: 'POST', body: input }),
  download: (customerId: string, accountId: string, statementId: string): Promise<Blob> =>
    apiFetchBlob(`${path(customerId, accountId)}/${encodeURIComponent(statementId)}/download`),
};
